export const BlockQuotation = 'blockquote';
//# sourceMappingURL=index.js.map